__turbopack_context__.v({
  "marquee": "ty_j8W_marquee",
  "root": "ty_j8W_root",
});
